import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
const breadcrumb: any[] = [
  {
    title: 'หน้าแรก'
    //link: '#'
  },
  {
    title: 'จัดการสิทธิ์ผู้ใช้งานระบบ'
    //link: '#'
  }
];

@Component({
  selector: 'page-user-permission',
  templateUrl: './permission.html',
  styleUrls: ['./permission.scss']
})

export class PageUserPermission implements OnInit {
  pageTitle: string = 'จัดการสิทธิ์ผู้ใช้งานระบบ';
  breadcrumb: any[] = breadcrumb;
  stateCtrl: FormControl;
  filteredStates: any;



  rows = [];
  temp = [];

  customers = [];
  key:any;
  fetchCustomer=[];
  loadingIndicator: boolean = true;

    //diaglog
    dialogRef: MdDialogRef<userDialog>;
    selectedOption: string;

  constructor( private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
   

    this.fetchcustomer((customer) => {
      this.customers = customer.map(function (val) {
        return [val.tc_company_shortname]
      });
      console.log('------this.model------', this.customers);
    });


    this.fetchall((data) => {

      console.log('------data------',data);
      this.rows = data;
      //setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });

    this.stateCtrl = new FormControl();
    this.filteredStates = this.stateCtrl.valueChanges
    .startWith(null)
    .map(name => this.filterStates(name));

   // console.log('-------this.filteredStates-----',this.filteredStates);
    
    this._sharedService.emitChange(this.pageTitle);
  }

    fetchcustomer(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_customer_name.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

  disableCustomer(tc_id:string){
    const req = new XMLHttpRequest();
    alert(tc_id);
    req.open('GET',  environment.url+'/api/disableCustomer.php?tc_id='+tc_id);

    req.onload = () => {
      console.log('---delect status ---',JSON.parse(req.response),tc_id);
      //JSON.parse(req.response);
    };

    req.send();
    for(let i =0;i<2;i++){
      this.fetchall((data) => {
        
              console.log('------data------',data);
              this.rows = data;
              //setTimeout(() => { this.loadingIndicator = false; }, 1500);
            });
    }

  }
  edit(tc_id:string){
    console.log('----ID----',tc_id);
    this.router.navigateByUrl('default-layout/customer-form-edit/'+tc_id);
  }



  fetch(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_customer.php?key='+this.key[0]);

    req.onload = () => {
      cb(JSON.parse(req.response));
    };
    req.send();
  }

  fetchall(cb) {
    const req = new XMLHttpRequest();
    req.open('GET',  environment.url+'/api/getJSON_customer.php');

    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }

search(){  
  
  console.log('---key-----',this.key,this.key[0],this.key[0].length);
 this.fetch((data) => {
      // cache our list
      this.temp = [...data];
      //this.model=data[0]['tp_productname'];
      // push our inital complete list

      console.log('------data------',data);
      this.rows = data;
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });
  }

  filterStates(val: string) {
   
    this.key=val;
 console.log('------val------',this.key);

    return val ? this.customers.filter((s) => new RegExp(val, 'gi').test(s)) : this.customers;
  }

  

  ngOnInit() {




  }


    openDialog(tc_id:string) {
    
    let dialogRef = this.dialog.open(userDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.disableCustomer(tc_id);
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.tc_company_shortname.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
}
//dialog
@Component({
  selector: 'user-dialog',
  templateUrl: 'dialog.html',
})
export class userDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<userDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/user/permission.ts